import { HttpService } from "../http/HttpService";
import { UserBonusEvent, UserBonusEventListResponse, UserBonusView } from "../http/protocol";
import { AbstractAdminEntityService } from "./AbstractAdminEntityService";

export class UserBonusEventService extends AbstractAdminEntityService<UserBonusEvent, UserBonusEventListResponse> {
  constructor(http: HttpService) {
    super("/user/bonus/event", http);
  }

  markCompleted(eventId: number): Promise<UserBonusView> {
    return this.http.put(`${this.entityPath}/markCompleted/${eventId}`, {});
  }
}
